// extracted by mini-css-extract-plugin
module.exports = {"root":"StaticReview_root__32N4y","title":"StaticReview_title__IP_Py","review":"StaticReview_review__OsWSr","author":"StaticReview_author__B2uOU","name":"StaticReview_name__YHPQ5"};